import React from 'react';

import styled, { CSSProp } from 'styled-components';

import {
  Heading as BaseHeading,
  withThemeProps,
} from '@techstyle/react-components';

const StyledHeading = styled(BaseHeading)<{ $textStyles?: CSSProp }>`
  ${({ $textStyles, level, theme }) =>
    $textStyles ||
    theme.header.variants[`h${level >= 3 ? 3 : level}`].textStyles}
`;

// The following type is copied from the `@techstyle/react-components` package
type HeadingProps = React.HTMLAttributes<HTMLHeadingElement> & {
  /**
   * The element type to render, defaults to an `h1`, `h2`, `h3` etc. depending
   * on the heading level.
   */
  as?: React.ElementType | keyof JSX.IntrinsicElements;
  /**
   * Override the heading level with a custom value. If given as a function, it
   * will be called with the current level so you can make a decision based on
   * it.
   */
  level?: number | ((value: number) => number);
  textStyles?: CSSProp;
};

function HeadingWrapper({ textStyles, ...rest }: HeadingProps) {
  return <StyledHeading $textStyles={textStyles} {...rest} />;
}

/**
 * A heading component built on top of the `Heading` component from
 * `@techstyle/react-components`. This version is configured to work with the
 * variant text styles available in the theme.
 */
export const Heading = withThemeProps<HeadingProps>(HeadingWrapper, {
  section: 'header',
  defaultVariant: 'h2',
});

type ParagraphProps = React.HTMLAttributes<HTMLParagraphElement> & {
  as?: React.ElementType | keyof JSX.IntrinsicElements;
};

const StyledParagraph = styled.p<{ textStyles?: CSSProp }>`
  ${({ textStyles }) => textStyles}
`;

export const Paragraph = withThemeProps<ParagraphProps>(StyledParagraph, {
  section: 'paragraph',
  defaultVariant: 'paragraph1',
});

const StyledSubheading = styled.p<{ textStyles?: CSSProp }>`
  ${({ textStyles }) => textStyles}
`;

export const Subheading = withThemeProps<ParagraphProps>(StyledSubheading, {
  section: 'subHeader',
  defaultVariant: 'subHeading1',
});
